function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M23.0625 10.6343C23.5803 10.6343 24 10.2221 24 9.71355V3.68286C24 1.65213 22.3177 0 20.25 0H3.75C1.68225 0 0 1.65213 0 3.68286V14.3171C0 16.3479 1.68225 18 3.75 18H20.25C22.3177 18 24 16.3479 24 14.3171C24 13.8086 23.5803 13.3964 23.0625 13.3964C22.5447 13.3964 22.125 13.8086 22.125 14.3171C22.125 15.3325 21.2839 16.1586 20.25 16.1586H3.75C2.71613 16.1586 1.875 15.3325 1.875 14.3171V3.87796L10.0198 8.8519C10.6305 9.22484 11.3152 9.41133 12 9.41133C12.6847 9.41133 13.3695 9.22484 13.9802 8.8519L22.125 3.87796V9.71355C22.125 10.2221 22.5447 10.6343 23.0625 10.6343ZM12.9901 7.28811C12.3794 7.66105 11.6206 7.66109 11.0099 7.28811L2.6573 2.18725C2.96517 1.96969 3.34261 1.84143 3.75 1.84143H20.25C20.6574 1.84143 21.0348 1.96973 21.3427 2.1873L12.9901 7.28811Z",
  fill: "#8295A6"
});

var SvgContacts = function SvgContacts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContacts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contacts.fc3a30cb.svg";
export { ForwardRef as ReactComponent };